(function (root, factory) {
  if (typeof exports === 'object' && typeof module !== 'undefined') {
    module.exports = factory();
  } else if (typeof define === 'function' && define.amd) {
    define(factory);
  } else {
    root.PdpStyleRuntime = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function normalizeStyleValue(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function resolveStyleEntry(styleValue, entries) {
    if (!styleValue || !Array.isArray(entries)) return null;
    var normVal = normalizeStyleValue(styleValue);
    if (!normVal) return null;

    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      var normName = normalizeStyleValue(entry.styleName || entry.style_name);
      if (normVal === normName || normVal === 'unisex ' + normName) return entry;
      var aliases = entry.aliases || [];
      for (var j = 0; j < aliases.length; j++) {
        if (normVal === normalizeStyleValue(aliases[j])) return entry;
      }
    }
    return null;
  }

  function resolveVariantStyle(variantId, variantStyleMap) {
    if (!variantId || !variantStyleMap) return null;
    return variantStyleMap[String(variantId)] || null;
  }

  function availableSizeValues(availability, styleValue) {
    if (!availability || !Array.isArray(availability.variants) ||
        availability.styleOptionIndex < 0 || availability.sizeOptionIndex < 0) return [];
    var values = [];
    for (var i = 0; i < availability.variants.length; i++) {
      var variant = availability.variants[i];
      if (!variant.available || !variant.options ||
          normalizeStyleValue(variant.options[availability.styleOptionIndex]) !== normalizeStyleValue(styleValue)) continue;
      var size = variant.options[availability.sizeOptionIndex];
      if (size !== undefined && values.indexOf(size) === -1) values.push(size);
    }
    return values;
  }

  function syncUnavailableSizeOptions(doc, availability, styleValue) {
    var available = availableSizeValues(availability, styleValue);
    if (!available.length) return;
    var selects = doc.querySelectorAll('select[name="options[Size]"]');
    for (var i = 0; i < selects.length; i++) {
      var options = selects[i].options;
      for (var j = 0; j < options.length; j++) {
        var enabled = available.indexOf(options[j].value) !== -1;
        options[j].disabled = !enabled;
        options[j].setAttribute('aria-disabled', String(!enabled));
      }
    }
  }

  function toggleBlockVisibility(blockEl, visible) {
    if (!blockEl) return;
    if (visible) {
      blockEl.classList.remove('pdp-style-hidden');
      blockEl.hidden = false;
      blockEl.style.display = '';
    } else {
      blockEl.classList.add('pdp-style-hidden');
      blockEl.hidden = true;
      blockEl.style.display = 'none';
    }
  }

  function findBlock(doc, blockId, defaultSelector) {
    if (!doc) return null;
    var el = null;
    if (blockId) {
      el = doc.querySelector('[data-block-id="' + blockId + '"]') ||
           doc.querySelector('[id*="' + blockId + '"]') ||
           doc.getElementById(blockId);
    }
    if (!el && defaultSelector) el = doc.querySelector(defaultSelector);
    if (el) el.setAttribute('data-pdp-dynamic-target', 'true');
    return el;
  }

  function findSizeGuideTargets(doc, blockId) {
    var modalId = 'PopupModal-' + blockId;
    var dialog = doc.getElementById ? doc.getElementById(modalId) : null;
    if (!dialog) dialog = findBlock(doc, blockId, null);
    var opener = doc.querySelector('[data-modal="#' + modalId + '"]');
    if (dialog) dialog.setAttribute('data-pdp-dynamic-target', 'true');
    if (opener) opener.setAttribute('data-pdp-dynamic-target', 'true');
    return { dialog: dialog, opener: opener };
  }

  function toggleTargets(targets, visible) {
    toggleBlockVisibility(targets.dialog, visible);
    toggleBlockVisibility(targets.opener, visible);
  }

  var NATIVE_SIZE_GUIDE_CONTENT = '.sizing-chart__top-image, .sizing-chart-table, .sizing-chart__caption';
  var SIZE_GUIDE_NOTICE_BLOCK_ID = 'shipping_checkpoint_size_guide_notice';

  function resolveSizeGuideHost(modalBody) {
    if (!modalBody || typeof modalBody.querySelector !== 'function') return null;
    var host = modalBody.querySelector('[data-pdp-size-guide-content]');
    if (host) return host;
    var doc = modalBody.ownerDocument;
    if (!doc || typeof doc.createElement !== 'function' || typeof modalBody.appendChild !== 'function') return null;
    host = doc.createElement('div');
    host.setAttribute('data-pdp-size-guide-content', '');
    modalBody.appendChild(host);
    return host;
  }

  function toggleNativeSizeGuideContent(modalBody, visible, host) {
    if (!modalBody || typeof modalBody.querySelectorAll !== 'function') return;
    var nodes = modalBody.querySelectorAll(NATIVE_SIZE_GUIDE_CONTENT);
    for (var i = 0; i < nodes.length; i++) {
      if (host && typeof host.contains === 'function' && host.contains(nodes[i])) continue;
      toggleBlockVisibility(nodes[i], visible);
    }
  }

  function owningAccordion(block) {
    if (!block || typeof block.closest !== 'function') return block;
    return block.closest('.product__accordion') || block;
  }

  function findAccordionByHeading(doc, heading) {
    if (!doc || !heading) return null;
    var summaries = doc.querySelectorAll('details > summary');
    for (var i = 0; i < summaries.length; i++) {
      var label = summaries[i].querySelector('h1, h2, h3, h4, h5, h6') || summaries[i];
      if (normalizeStyleValue(label.textContent) === normalizeStyleValue(heading)) {
        return summaries[i].parentElement;
      }
    }
    return null;
  }

  function applyStyle(rootDoc, entry, config) {
    var doc = rootDoc || document;
    var runtimeEl = doc.querySelector('[data-pdp-style-runtime]');
    if (!runtimeEl && !config) return;

    var sizeBlockId = (config && config.sizeBlockId) || (runtimeEl && runtimeEl.dataset.sizeBlockId);
    var sizeAccordionBlockId = (config && config.sizeAccordionBlockId) || (runtimeEl && runtimeEl.dataset.sizeAccordionBlockId);
    var shippingBlockId = (config && config.shippingBlockId) || (runtimeEl && runtimeEl.dataset.shippingBlockId);
    var sizeTargets = findSizeGuideTargets(doc, sizeBlockId);
    var sizeGuideAccordion = owningAccordion(
      findBlock(doc, sizeAccordionBlockId, null) || findAccordionByHeading(doc, 'Size Guide')
    );
    var shippingBlock = findBlock(doc, shippingBlockId, 'shipping-checkpoints, dynamic-dates, .shipping-checkpoints');
    var sizeGuideNotice = findBlock(doc, SIZE_GUIDE_NOTICE_BLOCK_ID, null);

    if (!entry) {
      toggleTargets(sizeTargets, false);
      toggleBlockVisibility(sizeGuideAccordion, false);
      toggleBlockVisibility(sizeGuideNotice, false);
      toggleBlockVisibility(shippingBlock, false);
      return;
    }

    var tpl = runtimeEl ? runtimeEl.querySelector('template[data-style-entry="' + entry.handle + '"]') : null;
    var sizeFrag = tpl ? tpl.content.querySelector('[data-fragment-size-guide]') : null;
    var sizeHtml = sizeFrag ? sizeFrag.innerHTML.trim() : '';
    if (sizeGuideAccordion) {
      var accordionContent = sizeGuideAccordion.querySelector('.accordion__content') || sizeGuideAccordion.querySelector('.collapsible-tab__content') || sizeGuideAccordion;
      if (sizeHtml) {
        accordionContent.innerHTML = sizeHtml;
        toggleBlockVisibility(sizeGuideAccordion, true);
      } else {
        toggleBlockVisibility(sizeGuideAccordion, false);
      }
    }
    if (sizeTargets.dialog || sizeTargets.opener) {
      var modalBody = sizeTargets.dialog && sizeTargets.dialog.querySelector('.sizing-chart__modal');
      var sizeHost = (sizeHtml && modalBody) ? resolveSizeGuideHost(modalBody) : null;
      if (sizeHost) {
        toggleNativeSizeGuideContent(modalBody, false, sizeHost);
        sizeHost.innerHTML = sizeHtml;
        toggleBlockVisibility(sizeHost, true);
        toggleTargets(sizeTargets, true);
        toggleBlockVisibility(sizeGuideNotice, true);
      } else {
        toggleTargets(sizeTargets, false);
        toggleBlockVisibility(sizeGuideNotice, false);
      }
    } else {
      toggleBlockVisibility(sizeGuideNotice, false);
    }

    var prodMin = entry.productionMinDays !== undefined ? entry.productionMinDays : entry.production_min_days;
    var prodMax = entry.productionMaxDays !== undefined ? entry.productionMaxDays : entry.production_max_days;
    var delivMin = entry.deliveryMinDays !== undefined ? entry.deliveryMinDays : entry.delivery_min_days;
    var delivMax = entry.deliveryMaxDays !== undefined ? entry.deliveryMaxDays : entry.delivery_max_days;
    var hasValidSla = prodMin !== undefined && prodMin !== null && prodMax !== undefined && prodMax !== null && delivMin !== undefined && delivMin !== null && delivMax !== undefined && delivMax !== null;

    if (shippingBlock) {
      if (!hasValidSla) {
        toggleBlockVisibility(shippingBlock, false);
      } else {
        var datesEl = shippingBlock.matches('dynamic-dates') ? shippingBlock : shippingBlock.querySelector('dynamic-dates');
        if (datesEl) {
          var checkpoints = datesEl.querySelectorAll('.shipping-checkpoint');
          if (checkpoints.length >= 3) {
            var ranges = [[0, 0], [prodMin, prodMax], [delivMin, delivMax]];
            for (var checkpointIndex = 0; checkpointIndex < 3; checkpointIndex++) {
              var dateNodes = checkpoints[checkpointIndex].querySelectorAll('[data-dynamic-date]');
              for (var dateIndex = 0; dateIndex < dateNodes.length; dateIndex++) {
                dateNodes[dateIndex].setAttribute('data-min-days', String(ranges[checkpointIndex][0]));
                dateNodes[dateIndex].setAttribute('data-max-days', String(ranges[checkpointIndex][1]));
              }
            }
          }
          if (typeof datesEl.insertDates === 'function') datesEl.insertDates();
        }
        toggleBlockVisibility(shippingBlock, true);
      }
    }
  }

  function parseEntriesFromDOM(runtimeEl) {
    var entries = [];
    if (!runtimeEl) return entries;
    var templates = runtimeEl.querySelectorAll('template[data-style-entry]');
    for (var i = 0; i < templates.length; i++) {
      var metaScript = templates[i].content.querySelector('script[data-entry-meta]');
      if (!metaScript) continue;
      try {
        var meta = JSON.parse(metaScript.textContent);
        entries.push({
          handle: meta.handle,
          styleName: meta.style_name,
          aliases: meta.aliases || [],
          productionMinDays: meta.production_min_days,
          productionMaxDays: meta.production_max_days,
          deliveryMinDays: meta.delivery_min_days,
          deliveryMaxDays: meta.delivery_max_days
        });
      } catch (e) {
        // Ignore invalid template JSON so a single bad entry cannot break PDP.
      }
    }
    return entries;
  }

  function boot(rootDoc) {
    var doc = rootDoc || document;
    var runtimeEl = doc.querySelector('[data-pdp-style-runtime]');
    if (!runtimeEl) return function () {};

    var mapScript = runtimeEl.querySelector('script[data-variant-style-map]');
    var variantMap = {};
    if (mapScript) {
      try { variantMap = JSON.parse(mapScript.textContent); } catch (e) { variantMap = {}; }
    }
    var availabilityScript = runtimeEl.querySelector('script[data-variant-availability]');
    var availability = null;
    if (availabilityScript) {
      try {
        var rawAvailability = JSON.parse(availabilityScript.textContent);
        availability = {
          styleOptionIndex: rawAvailability.style_option_index,
          sizeOptionIndex: rawAvailability.size_option_index,
          variants: rawAvailability.variants || []
        };
      } catch (e) {
        availability = null;
      }
    }
    var entries = parseEntriesFromDOM(runtimeEl);
    if (!entries.length) return function () {};

    var initialVariantId = runtimeEl.dataset.initialVariantId;
    var sizeBlockId = runtimeEl.dataset.sizeBlockId;
    function handleVariantChange(variantId) {
      if (!variantId) return;
      var styleValue = resolveVariantStyle(variantId, variantMap);
      applyStyle(doc, resolveStyleEntry(styleValue, entries));
      syncUnavailableSizeOptions(doc, availability, styleValue);
    }

    if (typeof runtimeEl._pdpStyleCleanup === 'function') runtimeEl._pdpStyleCleanup();
    if (initialVariantId) handleVariantChange(initialVariantId); else applyStyle(doc, null);
    doc.body.classList.add('pdp-style-runtime-ready');

    var unsubscribe = function () {};
    var hasNativeSubscription = typeof window !== 'undefined' && window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange;
    if (hasNativeSubscription) {
      unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.variant) handleVariantChange(event.data.variant.id);
      });
    }

    function onFormChange(evt) {
      var target = evt.target;
      if (target && (target.name === 'id' || target.matches('[name^="options"]') || target.matches('.single-option-selector'))) {
        var form = target.closest('form[action*="/cart/add"]') || doc.querySelector('form[action*="/cart/add"]');
        var idInput = form && form.querySelector('[name="id"]');
        if (idInput && idInput.value) handleVariantChange(idInput.value);
      }
    }
    if (!hasNativeSubscription) doc.addEventListener('change', onFormChange);

    function onSizeGuideLinkClick(evt) {
      var target = evt.target;
      if (!target || typeof target.closest !== 'function' || !sizeBlockId) return;
      var modalSelector = '#PopupModal-' + sizeBlockId;
      var link = target.closest('a[href="' + modalSelector + '"]');
      if (!link) return;
      var openerButton = doc.querySelector('[data-modal="' + modalSelector + '"] button');
      if (!openerButton) return;
      evt.preventDefault();
      openerButton.click();
    }
    function onSizeGuideTabClick(evt) {
      var target = evt.target;
      if (!target || typeof target.closest !== 'function') return;
      var btn = target.closest('.pdp-size-guide-tab-btn');
      if (!btn) return;
      var container = btn.closest('[data-fragment-size-guide], .product-size-chart-host, .accordion__content, .collapsible-tab__content, .sizing-chart__modal, .product-popup-modal');
      if (!container && btn.parentElement) container = btn.parentElement.parentElement;
      if (!container) return;
      var targetIndex = btn.getAttribute('data-guide-tab-index');
      if (targetIndex === null) return;

      var allBtns = container.querySelectorAll('.pdp-size-guide-tab-btn');
      for (var b = 0; b < allBtns.length; b++) {
        allBtns[b].classList.remove('is-active');
        allBtns[b].setAttribute('aria-selected', 'false');
      }
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      var entries = container.querySelectorAll('.pdp-size-guide-entry');
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].getAttribute('data-guide-entry-index') === targetIndex) {
          entries[k].style.display = 'block';
        } else {
          entries[k].style.display = 'none';
        }
      }
    }
    doc.addEventListener('click', onSizeGuideTabClick);

    var cleanup = function cleanup() {
      if (typeof unsubscribe === 'function') unsubscribe();
      if (!hasNativeSubscription) doc.removeEventListener('change', onFormChange);
      doc.removeEventListener('click', onSizeGuideLinkClick);
      doc.removeEventListener('click', onSizeGuideTabClick);
      if (runtimeEl._pdpStyleCleanup === cleanup) runtimeEl._pdpStyleCleanup = null;
    };
    runtimeEl._pdpStyleCleanup = cleanup;
    return cleanup;
  }

  return { normalizeStyleValue: normalizeStyleValue, resolveStyleEntry: resolveStyleEntry, resolveVariantStyle: resolveVariantStyle, availableSizeValues: availableSizeValues, applyStyle: applyStyle, boot: boot };
}));
